import { render, staticRenderFns } from "./InhaallesNieuw.vue?vue&type=template&id=4430c20a"
import script from "./InhaallesNieuw.vue?vue&type=script&lang=js"
export * from "./InhaallesNieuw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports